export default {
  tabs: {
    online_shop: 'Loja Online',
    reservations: 'Reservas',
    storefront: 'Loja',
  },
};
